// FILE: assets/js/map/markers.js
import L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

import popupTemplate from "../../../templates/popup-template.hbs";

// Marker cluster and map reference
export const markersCluster = L.markerClusterGroup({
    chunkedLoading: true,
    chunkInterval: 200,
    chunkProgress: (processed, total, elapsed, layersArray) => {
        if (typeof chunkProgressCallback === "function")
            chunkProgressCallback(processed, total, elapsed, layersArray);
    },
    chunkDelay: 50,
});

export const markerMap = new Map();
let mapRef = null;
let myIcon = null;
let templates = null;
let chunkProgressCallback = null;

export default {
    init(mapInstance, { templates: t, updateProgressUI } = {}) {
        if (!mapInstance) {
            console.error("MarkersModule.init: mapInstance is required");
            return;
        }

        mapRef = mapInstance;
        templates = t;
        chunkProgressCallback = updateProgressUI;

        myIcon = L.icon({
            iconUrl: "/wp-content/uploads/2023/01/marker.svg",
            iconSize: [24, 24],
            iconAnchor: [12, 24],
            popupAnchor: [0, -50],
        });

        // Add cluster to map if not already present
        if (!mapRef.hasLayer(markersCluster)) mapRef.addLayer(markersCluster);
    },

    async loadMarkers({ bounds, extraParams = new URLSearchParams() } = {}) {
        if (!mapRef) {
            console.error(
                "MarkersModule.loadMarkers: mapRef is undefined. Call init(map) first."
            );
            return;
        }

        if (!bounds) return;

        const params = new URLSearchParams(extraParams.toString());
        params.set("bounds", bounds);
        params.set("status", "EV");
        params.set("limit", "1000");

        const url = `${
            window.ajaxObject.ajax_url
        }?action=search_listings&${params.toString()}`;

        try {
            const res = await fetch(url);
            const json = await res.json();
            const results = json?.results || [];

            // remove old markers
            const mlsSet = new Set(results.map((p) => p.property.mls_no));
            for (const [mls, marker] of markerMap) {
                if (!mlsSet.has(mls)) {
                    markersCluster.removeLayer(marker);
                    markerMap.delete(mls);
                }
            }

            // add new markers
            for (const property of results) {
                const mls = property.property.mls_no;
                if (!markerMap.has(mls)) {
                    const lat = parseFloat(property.property.latitude);
                    const lng = parseFloat(property.property.longitude);
                    if (Number.isNaN(lat) || Number.isNaN(lng)) continue;

                    const marker = L.marker([lat, lng], { icon: myIcon });

                    marker.on("click", () => {
                        if (!marker.getPopup()) {
                            const html = popupTemplate(property);
                            marker.bindPopup(html).openPopup();
                        }
                    });

                    markerMap.set(mls, marker);
                    markersCluster.addLayer(marker);
                }
            }

            if (!mapRef.hasLayer(markersCluster))
                mapRef.addLayer(markersCluster);
        } catch (err) {
            console.error("Error fetching markers:", err);
        }
    },

    clearAll() {
        if (!mapRef) return;
        markersCluster.clearLayers();
        markerMap.clear();
    },
};
